import type { GameV1 } from '@/api/games';

export const createGamesSlides = (
  games: GameV1[],
  cols: number,
  rows: number
) => {
  const blocks = [];
  const blockSize = cols * rows;
  let i = 0;

  while (i < games.length) {
    const blockGames = games.slice(i, i + blockSize);
    const missing = blockSize - blockGames.length;

    blocks.push({
      games: blockGames,
      cols,
      rows,
      plugs: missing > 0 ? Array(missing).fill(null) : [],
    });

    i += blockSize;
  }

  return blocks;
};
